import request from './request'

// 获取体测项目列表
export const getTestItems = () => {
  return request.get('/sports/tests/items')
}

// 录入体测成绩
export const recordScore = (data) => {
  return request.post('/sports/tests/records', data)
}

// 查询学生体测成绩
export const queryScores = (params) => {
  return request.get('/sports/tests/records', { params })
}

// 获取学生详情
export const getStudentDetail = (studentId) => {
  return request.get(`/academic/students/${studentId}`)
}

// 获取班级列表
export const getClasses = (params) => {
  return request.get('/academic/classes', { params })
}

// 获取班级学生列表
export const getClassStudents = (classId) => {
  return request.get(`/academic/classes/${classId}/students`)
}

// 获取统计信息
export const getStatistics = (params) => {
  return request.get('/sports/tests/statistics', { params })
}

// 获取体测导出预览及统计数据 (成绩大盘与导出预览共用)
export const getPhysicalTestExportPreview = (params = {}) => {
  return request.get('/sports/tests/export/', {
    params: {
      ...params,
      include_statistics: true
    }
  })
}

// 导出真实 Excel 报表文件 (.xlsx 格式二进制流)
export const downloadPhysicalTestExcel = (params = {}) => {
  return request.get('/sports/tests/export-file/', {
    params,
    responseType: 'blob'
  })
}

// 兼容旧接口
export const exportData = (params) => {
  return request.get('/sports/tests/export/', { 
    params,
    responseType: 'blob'
  })
}

// V2 标准体测成绩接口
export const getPhysicalTests = (params = {}) => {
  return request.get('/sports/tests/', { params })
}

export const savePhysicalTest = (data) => {
  return request.post('/sports/tests/', data)
}

export const batchImportTests = (data) => {
  return request.post('/sports/tests/batch-import/', data)
}

